module.exports = __webpack_public_path__ + "static/media/virus.8172e304.svg";